import "./styles.less";

import React, { ReactElement, useContext,useMemo } from "react";

import { FormButton } from "./FormButton/web";
import { ButtonsLeadsSource, ModalState } from "../TextForm/type";

import dynamic from "next/dynamic";
import { useTheme } from "shared-components/Styles/ThemeHook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { FormCallToActions, useContactModal } from "shared-components/Contexts/ContactModal/context";

import { useUser } from "shared-components/Components/User/User.hook";
import { getInitialContactForm, requiresContactData } from "src/utils/Functions";
import { CountryCode, isValidPhoneNumber, parsePhoneNumberWithError } from "libphonenumber-js";

//@ts-ignore
const WhatsappButton = dynamic(
	() => import("./WhatsappButton/web").then(mod => mod.WhatsappButton),
	{ ssr: false }
);
const PhoneButton = dynamic(() => import("./PhoneButton/web").then(mod => mod.PhoneButton), {
	ssr: false,
});

export const LeadButtons = ({
	id,
	children = null,
	disabled = false,
	isInListing = false,
	queryRouter,
	onWpClick,
	forceState = ModalState.DEFAULT,
	idealFilters,
	isProject,
	owner,
	seller,
	projectId,
	setDataModal,
	hasAcceptedTerms = true,
	onTermsError,
	onBeforeAction,
	source = "",
	propertyLink,
	ctaToShow = {
		contact: true,
		phone: true,
		whatsapp: true
	}
}: {
	id: any;
	children?: ReactElement;
	disabled?: boolean;
	isInListing?: boolean;
	queryRouter?: string;
	onWpClick?: () => void;
	forceState?: ModalState;
	idealFilters?: any;
	isProject?: boolean;
	owner?: any;
	seller?: any;
	projectId?: number;
	setDataModal?: any;
	hasAcceptedTerms?: boolean;
	onTermsError?: (e) => void;
	onBeforeAction?: (e, cta: "phone" | "whatsapp") => boolean;
	source?: ButtonsLeadsSource;
	propertyLink?: string;
	ctaToShow?: FormCallToActions
}) => {
	const {theme} = useTheme();
	const { site_name, country_code } = useContext(ConfigStateContext);
	const { openContactModal, closeContactModal } = useContactModal();
	const resolvedId = isProject ? (projectId ?? id) : id;
	const hasPhone = seller ? seller?.masked_phone : owner?.masked_phone;
	const askDataBeforeContact = requiresContactData(country_code);
	const showContactModal = source === "card" || (askDataBeforeContact && !onBeforeAction && source === "propertyDetailMain");
	const defaultMessage = `Hola, vi esta propiedad en ${site_name} y me interesa recibir más información. ¡Muchas gracias!`;

	const { user: { data: dataUser }, isLoggedIn } = useUser();
	const contactForm = getInitialContactForm(isLoggedIn, dataUser);

	const shouldAskForData = useMemo(() => {
		if (!showContactModal || !askDataBeforeContact) return false;

		const data = isLoggedIn ? dataUser?.me : contactForm;

		const phone = data?.phone;
		const incompleteData =
			!data?.name || data?.name === '' ||
			!data?.email || data?.email === '' ||
			!data?.phone || data?.phone === '';

		let validPhone = true;
		try {
		  if (data?.phone) {
			const parsed = parsePhoneNumberWithError(phone, { defaultCountry: country_code as CountryCode });
			validPhone = isValidPhoneNumber(data?.phone, parsed?.country as CountryCode);
		  }
		} catch(err) {
			validPhone = false;
		}
		return incompleteData || !validPhone;

	  }, [country_code, dataUser, isLoggedIn, contactForm, showContactModal]);

	const handleOpenContactModal = ({ ctaButtons } : { ctaButtons: FormCallToActions }) => {		
		openContactModal({
			id: resolvedId,
			owner,
			isProject: isProject ?? false,
			projectId: isProject ? (projectId ?? resolvedId) : projectId,
			defaultMessage,
			source: source,
			propertyLink,
			ctaToShow: ctaButtons
		});
	}

	return (
		<div className={`property-lead-button ${askDataBeforeContact ? "grid" : "inline" } ${isInListing ? "in-listing" : "not-listing"}`} style={isInListing ? { textAlign: "right" } : null}>
			{ctaToShow && ctaToShow.contact ? 
				children ? (
					<div>{children}</div>
				) : (
					<div><FormButton
						disabled={disabled}
						idealFilters={idealFilters ?? undefined}
						callback={handleOpenContactModal}
					/></div>
				) 
			: null}

			{hasPhone && (ctaToShow && ctaToShow.phone) ? (
				<div>
					<PhoneButton
						id={resolvedId}
						type={"callButton"}
						forceState={forceState}
						disabled={disabled}
						queryRouter={queryRouter}
						owner={owner}
						isProject={isProject}
						hasAcceptedTerms={hasAcceptedTerms}
						onTermsError={onTermsError}
						onBeforeAction={onBeforeAction}
						color={theme.colors.primaryColor}
						callback={showContactModal ? handleOpenContactModal : null}
						handleCloseContactModal={closeContactModal}
						source={source}
						shouldAskForData={shouldAskForData} 
					/>
				</div>
			): null}

			{owner && owner.has_whatsapp && (ctaToShow && ctaToShow.whatsapp) ? (
				<div>
					<WhatsappButton
						id={resolvedId}
						setDataModal={setDataModal}
						disabled={disabled}
						forceState={forceState}
						onWpClick={onWpClick}
						queryRouter={queryRouter}
						owner={owner}
						isProject={isProject}
						hasAcceptedTerms={hasAcceptedTerms}
						onTermsError={onTermsError}
						onBeforeAction={onBeforeAction}
						callback={showContactModal ? handleOpenContactModal : null}
						handleCloseContactModal={closeContactModal}
						source={source}
						propertyLink={propertyLink}
						shouldAskForData={shouldAskForData} 
					/>
				</div>
			) : null}
		</div>
	);
};
